/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaCittadinoSummaryDTO } from '../model/models';
import { PraticaCittadinoEligibilitaDTO } from '../model/models';
import { TipoPraticaCittadinoListFilter } from '../model/models';
import { TipoPraticaCittadinoStatoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetEligibilitaTipoPraticaCittadinoRequestParams {
    slug: string;
    id: string;
}

export interface GetStatoTipoPraticaCittadinoRequestParams {
    slug: string;
    id: string;
}

export interface ListTipiPraticaCittadinoRequestParams {
    slug: string;
    filter: TipoPraticaCittadinoListFilter;
    pageable: Pageable;
}


export interface CittadinoCatalogoBandiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Eleggibilita\&#39; al submit del cittadino per un bando: { can_submit, reason }. reason e\&#39; una chiave i18n sempre presente. 404 se il bando non e\&#39; visibile al cittadino. Il path variable {id} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune dello slug).
     * 
     * @endpoint get /api/v1/cittadino/comuni/{slug}/tipi-pratica/{id}/eligibilita
* @param requestParameters
     */
    getEligibilitaTipoPraticaCittadino(requestParameters: GetEligibilitaTipoPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaCittadinoEligibilitaDTO>;

    /**
     * Info leggera { titolo, stato } di un bando con visualizzazione&#x3D;PUBBLICA in qualsiasi stato (incluso IN_ATTESA). Nessuna data esposta. 404 privacy-preserving se il bando non e\&#39; PUBBLICA / inesistente / di altro comune. Il path variable {id} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune dello slug). Nessuna autenticazione richiesta.
     * 
     * @endpoint get /api/v1/cittadino/comuni/{slug}/tipi-pratica/{id}/stato
* @param requestParameters
     */
    getStatoTipoPraticaCittadino(requestParameters: GetStatoTipoPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaCittadinoStatoDTO>;

    /**
     * Lista paginata dei TipoPratica visibili al cittadino per un comune. Filtri opzionali: tipologia, solo_aperti (Boolean), q (substring titolo+descrizione). Ordinamento: bandi aperti alla presentazione (RICEZIONE_RICHIESTE, NUOVA_RICEZIONE_RICHIESTE) sempre in testa, gli altri sotto; dentro ciascun gruppo vale il sort richiesto. Default sort: data_apertura DESC.
     * 
     * @endpoint get /api/v1/cittadino/comuni/{slug}/tipi-pratica
* @param requestParameters
     */
    listTipiPraticaCittadino(requestParameters: ListTipiPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaCittadinoSummaryDTO>;

}
